const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user editor directive to manage edits on user objects
 */

app.directive('addContentModal', [function() {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      context: '@',
      onClose: '&',
      onAdd: '&',
      open: '=',
      omittedContentTypes: '=',
      originalContent: '=',
      resultParse: '&?',
      disclaimer: '<'
    },
      template: require('../../../templates/directives/cms/add-content-modal.html'),
      controller: ['$scope', function($scope) {
        var self = this;
        self.selected = [];
        self.availabilityInDays = 0;

        const formatSelected = function(selected) {
          if (self.availabilityInDays > 0) {
            items = self.selected.map(item => {
              return {...item, availabilityInDays: self.availabilityInDays};
            });
            self.availabilityInDays = 0;
            return items;
          } else {
            return selected;
          }
        };

        self.addSelected = function() {
          const items = formatSelected(self.selected);   
          $scope.onAdd({items: items});
          self.close();
        };

        self.resultParse = function(item) {
          if ($scope.resultParse) {
            return $scope.resultParse({item: item});
          }
          return true;
        };

        self.disableCriteria = $scope.context === 'journey';

        self.close = function() {
          $scope.onClose();
          self.selected = [];
        };
      }],
      controllerAs: 'add'
    };
  }]);